import { IKeyValuePair } from "../interfaces-and-types";

export const summaryTableData: IKeyValuePair[] = [
  {
    key: "Total customers",
    value: 20,
  },
  {
    key: "New customers",
    value: 10,
  },
  {
    key: "Unsuccessful Transaction",
    value: 5,
  },
  {
    key: "Feedback",
    value: 10,
  },
  {
    key: "Payment Gateways",
    value: 6,
  },
];
